const MESSAGES = {
  ALLERGY: {
    DELETE: {
      CONFIRMATION: {
        MESSAGE: 'Are you sure you want to delete this allergy?',
        CONFIRM_BUTTON: 'Delete allergy',
        CANCEL_BUTTON: 'Cancel',
      },
    },
    ADD: {
      BUTTON_TEXT: 'Add allergy',
    },
    LIST: {
      TITLE: 'Allergies list',
      CAPSULE_TITLE: 'Your allergies',
    },
  },
  TASK: {
    TITLE: 'Tasks',
    DESCRIPTION: 'Complete the tasks below before your next appointment',
    TASK_COMPLETED: 'Completed',
    COMPLETED: {
      TITLE: 'Questionnaire completed!',
      DESCRIPTION:
        "If you haven't already, please take a moment to finish the remaining questionnaires.",
      BUTTON_TEXT: 'Go back to tasks',
    },
  },
  DASHBOARD: {
    MEDICATION_CONSISTENCY: 'Your medication chart',
  },
  MEDICATION: {
    DELETE: {
      CONFIRMATION: {
        MESSAGE: 'Are you sure you want to delete this medication?',
        CONFIRM_BUTTON: 'Delete medication',
        CANCEL_BUTTON: 'Cancel',
      },
    },
    ADD: {
      BUTTON: 'Add medication',
    },
    LIST: {
      TITLE: 'Medication list',
      DESCRIPTION: 'Complete the tasks below before your next appointment',
      CAPSULE_TITLE: 'Your medications',
    },
    TRACKER: {
      TITLE: 'Your medication chart',
      DESCRIPTION:
        "Check how consistently you've taken your medications this week",
    },
  },
  LIFESTYLE: {
    TITLE: 'Lifestyle',
    DESCRIPTION:
      'Complete our lifestyle questionnaire to enhance personalized well-being and receive personalized recommendations.',
    BUTTON_CONTINUE: 'Complete questionnaire',
  },
  MEDICAL_HISTORY: {
    TITLE: 'Medical history',
    DESCRIPTION:
      'Complete our pre-surgery questionnaire to ensure your safety and receive personalized care.',
    BUTTON_CONTINUE: 'Complete questionnaire',
  },
  USER: {
    DELETE: {
      FAIL: {
        FUTURE_APPOINTMENT: {
          TITLE: "Your account can't be deleted",
          DESCRIPTION:
            'You are unable to delete your account because you have a scheduled appointment. If you need assistance, please contact us.',
          BUTTON_NAME: 'I understood',
        },
      },
    },
  },
};

Object.freeze(MESSAGES);

export default MESSAGES;
